import { Label, Spinner } from '@acpaas-ui/react-components';
import Skeleton from 'react-loading-skeleton';
import OfferingsTitle from '../../../../../components/offerings/OfferingsTitle';
import { gcpSchoolToType } from '../../../../../lib/schools.utils';

const AdminSchoolsSearchResults = ({ results, onResultSelect, isLoading, compact, showResults = true }) => {
  const renderResultCountLabel = () => {
    if (!showResults) {
      return null;
    }

    if (compact) {
      return (
        <h6 className="u-margin-bottom-xs">
          Resultaat ({isLoading ? <Spinner className="u-inline-block" /> : results?.length ?? 0})
        </h6>
      );
    }

    return (
      <OfferingsTitle>
        Resultaat ({isLoading ? <Spinner className="u-inline-block" /> : results?.length ?? 0})
      </OfferingsTitle>
    );
  };

  return (
    <div className={`spo-m-admin-school-search-results ${compact ? 'is-compact' : ''}`}>
      {renderResultCountLabel()}
      {isLoading ? (
        <>
          <div className="spo-m-admin-school-search-results__list-item u-border">
            <Skeleton />
          </div>
          <div className="spo-m-admin-school-search-results__list-item u-border">
            <Skeleton />
          </div>
          <div className="spo-m-admin-school-search-results__list-item u-border">
            <Skeleton />
          </div>
        </>
      ) : showResults ? (
        results?.map((result) => (
          <div
            key={result.id}
            className="spo-m-admin-school-search-results__list-item u-border"
            role="link"
            onClick={() => onResultSelect(result)}
          >
            <div className="spo-m-admin-school-search-results__list-item-title">
              <h6 className="u-text-bold u-text-primary">
                {result?.spoEntityData?.shadow?.name || result?.spoEntityData?.agodi?.name}
              </h6>
              <Label className="u-margin-right-sm" type="primary">
                {gcpSchoolToType(result)}
              </Label>
            </div>
          </div>
        ))
      ) : null}
    </div>
  );
};

export default AdminSchoolsSearchResults;
